import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { NicknameContainer as c, TopCreatorIcon as m } from "./style.js";
import { useTranslation as s } from "../../hooks/useTranslation/index.js";
import { CircleStar as p } from "@pelando/fontawesome/icons";
const x = ({
  children: a,
  isVerified: n,
  isInactive: r,
  ...t
}) => {
  const { t: i } = s("common");
  return /* @__PURE__ */ e(c, { ...t, children: [
    /* @__PURE__ */ o("span", { "data-testid": "span-nickname", children: a }),
    n && /* @__PURE__ */ o(
      m,
      {
        "data-inactive": r,
        icon: p,
        "aria-label": i("nickname-top-creator-icon-label")
      }
    )
  ] });
};
export {
  x as Nickname
};
